import imageCompression from 'browser-image-compression';

export class FileProvider {
  async compressImage(file: File, maxSizeMB: number, maxWidthOrHeight: number, quality = 1): Promise<File> {
    return imageCompression(file, {
      maxSizeMB,
      maxWidthOrHeight,
      useWebWorker: true,
      initialQuality: quality,
    });
  }

  transformImageToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result as string)
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }
}